import React from 'react';

import {FindUsagesResult} from './find-usages-result';
import {Sidebar} from '../../../../../components/layout/sidebar';
import {useSuggestionsProps} from '../../../common/sidebar-search-field/hooks/use-suggestions-props';
import {useHandleFindUsages} from '../../../common/sidebar-search-field/hooks/use-handle-find-usages';
import {FlatSearchResult} from './flat-search-result';
import {EditViewSidebarProps} from '../interface';
import {SidebarHeader} from '../../../../../components/layout/sidebar/sidebar-header/sidebar-header';
import {SidebarSearchField} from '../../../common/sidebar-search-field/sidebar-search-field';
import {useSidebarSearchProps} from '../../../common/sidebar-search-field/hooks/use-sidebar-search-props';
import {
    isSearchByDocName,
    isSearchByMetadata,
    isSearchCategory,
    isSearchNode
} from '../../../common/sidebar-search-field/suggestion-helpers';
import {useDocumentSidebarState} from '../../../common/right-sidebar/hooks/use-document-sidebar-state';

interface Props extends EditViewSidebarProps {
    documentId?: string;
    revisionId?: string;
    searchSidebarContext: ReturnType<typeof useSidebarSearchProps>;
    findUsagesProps: ReturnType<typeof useHandleFindUsages>;
    getDocumentLink: (documentId: string, nodeId?: string) => string;
    rightSidebarProps: ReturnType<typeof useDocumentSidebarState>;
}

export const SearchLayout = (props: Props) => {
    const suggestionsProps = useSuggestionsProps({
        inputPrefix: props.searchSidebarContext.inputPrefix,
        inputValue: props.searchSidebarContext.inputValue
    });

    return (
        <Sidebar
            component="div"
            border="right"
            header={
                <SidebarHeader title="Search" onClose={props.closeSidebar}>
                    <SidebarSearchField
                        disabled={props.findUsagesProps.loadingNodeType || !!props.revisionId}
                        busy={suggestionsProps.isLoading || props.findUsagesProps.loadingNodeType}
                        suggestionsProps={suggestionsProps}
                        searchSidebarProps={props.searchSidebarContext}
                    />
                </SidebarHeader>
            }
        >
            {(function () {
                const {searchData} = props.searchSidebarContext;

                if (!searchData) {
                    return null;
                }

                if (
                    isSearchByDocName(searchData) ||
                    isSearchCategory(searchData) ||
                    isSearchByMetadata(searchData)
                ) {
                    return (
                        <FlatSearchResult
                            searchData={searchData}
                            rightSidebarProps={props.rightSidebarProps}
                            documentId={props.documentId}
                        />
                    );
                }

                if (isSearchNode(searchData)) {
                    return (
                        <FindUsagesResult
                            searchData={searchData}
                            getDocumentLink={props.getDocumentLink}
                        />
                    );
                }
            })()}
        </Sidebar>
    );
};
